import { render } from "./BookingUpsell.vue?vue&type=template&id=355e311a"
import script from "./BookingUpsell.vue?vue&type=script&lang=js"
export * from "./BookingUpsell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingUpsell.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "355e311a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('355e311a', __exports__)) {
    api.reload('355e311a', __exports__)
  }
  
  module.hot.accept("./BookingUpsell.vue?vue&type=template&id=355e311a", () => {
    api.rerender('355e311a', render)
  })

}


export default __exports__